import React, { useCallback, useEffect, useState } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';
import Image404 from 'public/images/shy-lens.png';
import Image from 'frontastic/lib/image';
import debounce from 'lodash.debounce';
import { useParams, redirect, useRouter } from 'next/navigation';

const NotFound = () => {
  const { formatMessage } = useFormat({ name: 'common' });
  const router = useRouter();
  const { locale } = useParams();
  const [count, setCount] = useState(5);

  const clearImage = useCallback(
    debounce(() => router.push(`/${locale}/`), 5000),
    [],
  );
  useEffect(() => {
    clearImage();
  }, []);

  useEffect(() => {
    // each second count=count-1
    const interval = setInterval(() => {
      setCount((updatedCount) => updatedCount - 1);
    }, 1000);
    // if count===0 redirect

    count === 0 && router.push(`/${locale}/`);

    // always clear the timeers in return function
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <div className="relative h-[80vh] lg:h-[60vh]">
      <div className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-0 pb-60 lg:flex-row-reverse lg:gap-50">
        <div className="mt-5 text-center ">
          <h1 className="text-32">{formatMessage({ id: 'page.notFound', defaultMessage: 'Page not found' })}</h1>
          <p className="mt-24">
            {formatMessage({
              id: 'page.notFound.desc',
              defaultMessage:
                "The page you were looking for couldn't be found. It may have been deleted, renamed, or doesn't exist.",
            })}
          </p>
          <p  className="mt-20">
            Redirecting to homepage in 
            {count >= 0 ? ' '+ count : ' ' + 0} {count > 1 ? 'seconds' : 'second'}.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
